export const checkNullString = (str: string) => {
    return str === null || str ===' ' ? '' : str
}